/** A whole HTML document in an agent reply (the drill plan handout), not chat text. */
export function isHtmlDocument(text: string): boolean {
  return /^\s*(?:<!doctype html|<html[\s>])/i.test(text || '');
}

/** The document's <title>, for the handout card label and the download name. */
export function handoutTitle(html: string): string {
  const title = /<title[^>]*>([^<]*)<\/title>/i.exec(html)?.[1]?.trim();
  return title || 'Drill plan handout';
}

/** A safe file name for the downloaded handout. */
export function handoutFileName(title: string): string {
  const base = title.replace(/[^\w\s-]+/g, '').trim().replace(/\s+/g, '-');
  return `${base || 'drill-plan'}.html`;
}
